module.exports = __webpack_public_path__ + "img/th.872567a5.svg";